<div class="flex items-center justify-between">
  <div class="flex items-center">
    <mat-icon svgIcon="image" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'BASE_IMAGE.TITLE' | transloco}}
      <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (baseImageData?.length || 0)}})</span>
    </div>
    <div [ngClass]="{'filter-disabled': !allBaseImageData?.length || showLoader}"
      class="ml-16 search-component">
      <app-search-filter class="ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button
      [ngClass]="{'disabled': !allBaseImageData?.length || showLoader}"
      class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter"
      (click)="openFilter()">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
      @if (filterStartDate && filterEndDate) {
        <span class="filter-active-dot"></span>
      }
    </button>
  </div>
  @if (allBaseImageData?.length > 0) {
  <div class="flex flex-row gap-3 create-runbook">
    <!-- <mat-icon svgIcon="info" class="top-space cursor-pointer icon-md mt-16" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="'BASE_IMAGE.ONCE_PER_MONTH_NOTE' | transloco"></mat-icon> -->
    <button type="submit" class="flex accent h-32 fw-700 place-items-center mt-16 mr-8"
      [ngClass]="{ 'disabled': showLoader || isUpdatePending || isRollbackPending || inProgressBaseImage || (instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING) : !isBaseImageEnabled) }"
      (click)="onUpdateClick()">
      {{ 'BUTTONS.UPDATE' | transloco }}
    </button>
    <span style="display: inline-block"
      matTooltipClass="above" matTooltipPosition="above"
      [matTooltipDisabled]="!!inProgressBaseImage || !remainingTimeDisplay || remainingTimeDisplay === '00:00:00'"
      [matTooltip]="'BASE_IMAGE.ROLLBACK_NOTE' | transloco : {remainingTimeDisplay: remainingTimeDisplay}">
      <button type="submit" class="flex accent h-32 fw-700 place-items-center mt-16 mr-8"
        [ngClass]="{ 'disabled': showLoader || isUpdatePending || isRollbackPending || (remainingTimeDisplay && remainingTimeDisplay !== '00:00:00') || inProgressBaseImage || (instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING) : !isBaseImageEnabled) }"
        (click)="onRollbackClick()">
        {{ 'BUTTONS.ROLLBACK' | transloco }}
      </button>
    </span>
    <span class="vertical-dash top-space mr-4 mt-16"></span>
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer"
      (click)="refreshClick()">
      <mat-icon svgIcon="refresh" class="icons transition-transform duration-700"
        [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div>
    <app-environment-paginator [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize"
      (page)="onPageChange($event)"></app-environment-paginator>
  </div>
  }
</div>
<div *ngIf="filterStartDate && filterEndDate" class="flex flex-row flex-wrap items-center ml-8 mt-8">
  <span class="pr-8 fs-16">{{ 'SCHEDULE_DETAILS.MODIFIED_DATE' | transloco }}:</span>
  <div class="mr-4 filtered-items flex items-center fs-16 fw-500">
    <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
      {{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
      <span class="ml-8">
        <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelFilter()"></mat-icon>
      </span>
    </span>
  </div>
</div>
<mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
@if (allBaseImageData?.length > 0 && !showLoader) {
<div class="flex flex-col border-radius route-table envt-schedule mb-16 mt-8">
  <app-environment-table class="runbook-table" [ngClass]="{'disabled': showLoader}"
    (searchedResults)="searchedItems($event)" [displayColumns]="displayColumns" [showSkeletonLoader]="showLoader"
    [initialDataSource]="baseImageData" [dataLoading]="showLoader" [searchTerm]="searchTerm" [dataSourceLength]="true"
    [initialCreate]="false" (pageChanged)="onPageChange($event)" (sorted)="resetPaginator()"
    (pageModify)="onTablePageChanged($event)"
    (retryBaseImage)="onRetryClick($event)"
    (nameClick)="onNameClick($event)"
    [data]="instance"
    pageName="environmentBaseImage"></app-environment-table>
</div>
}

@if (allBaseImageData?.length === 0 && !showLoader) {
<div class="flex flex-col">
  <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
    <div class="empty-data flex flex-col items-center mt-32">
      <img class="w-106" alt="base image not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6">{{'BASE_IMAGE.NO_DATA' | transloco}}</div>
    </div>
    <div class="flex justify-center items-center mt-24">
      <!-- <mat-icon svgIcon="info" class="cursor-pointer icon-md ml-8 mr-8" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="'BASE_IMAGE.ONCE_PER_MONTH_NOTE' | transloco"></mat-icon> -->
      <button type="button" class="flex accent justify-center items-center mat-subtitle-2" mat-button
        [ngClass]="{ 'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || !isBaseImageEnabled) : !isBaseImageEnabled }"
        (click)="onUpdateClick()">
        {{'BASE_IMAGE.UPDATE_BASE_IMAGE' | transloco}}
      </button>
    </div>
  </div>
</div>
}
@if (showLoader) {
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
      <div class="loader-style">
        <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
      </div>
      }
    </div>
  </div>
  @for (item of [1, 2, 3]; track $index) {
  <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
}
